import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import React, { useEffect } from 'react'

import { ImageUpload } from 'pages/CoachOnboarding/subcomponents/ImageUpload'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'

import { useProgram } from 'hooks/useProgram'

import { links } from 'utils/constants'

import { useCoachOnboardingModal } from 'contexts/CoachOnboardingModalContext'

import { Program } from 'types/program'

type ProgramImagePageProps = {
  route?: any
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}

export const ProgramImagePage = ({ route, drawerNavigationRef }: ProgramImagePageProps) => {
  const programData = route?.params?.program as Program | undefined
  const coachOnboardingModalRef = useCoachOnboardingModal()

  const { updateProgram } = useProgram(programData?.id)

  useEffect(() => {
    if (!programData) return
    updateProgram.mutateAsync(programData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigateToProgramPage = () => {
    coachOnboardingModalRef?.current?.dismiss()
    drawerNavigationRef?.current?.navigate(links.PROGRAM_PAGE, { programId: programData?.id })
  }

  return (
    <Box flex={1} backgroundColor='white'>
      <BottomSheetNav withBack backgroundColor='white' />
      <ImageUpload
        programId={programData?.id}
        textColor='black'
        buttonBackground='v2primary'
        promptTitle='Add Cover Image'
        promptSubtitle='You can always change this later.'
        onNext={navigateToProgramPage}
      />
      <Box />
    </Box>
  )
}
